import dayjs from 'hb-react/shared/utils/dayjs/dayjs';

export const makeSubheaderFromDates = ({
  createdAt,
  updatedAt,
}: {
  createdAt: string;
  updatedAt: string;
}) => {
  const delayFromPublication = dayjs(new Date(createdAt)).fromNow();
  const delayFromUpdate = dayjs(new Date(updatedAt)).fromNow();
  const updatedText = s__('Forum|Updated %{delay}').i__({
    delay: delayFromUpdate,
  });

  return `${delayFromPublication}${
    delayFromPublication !== delayFromUpdate ? ` · ${updatedText}` : ''
  }`;
};
